/**
 * Fictora 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Fictora 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '',
  // 标签模块背景图（fictora 不显示背景）
  tagsBg: '',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FF2D89',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FF8AB9',
  tagInactiveText: '#FFFFFF',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F4F1FF 0%, #FF2D89 95%)',
  // 不显示 Tab 热点图标
  showHotTabIcon: false,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
